<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-sidewindow-balance'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('add')} ${$t('balance')}`"
    :searchButton="true"
    :searchFlag="searchFlag"
    :badgeButtons="
      filterExists
        ? [
            {
              text: 'Reset Filters',
              value: 'reset_filters',
              icon: 'delete-white',
            },
          ]
        : []
    "
    @addClick="onAddClick"
    @menuClick="onRightMenuClick"
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <InputField
          :value="searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            width: '124px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          :options="balanceTypeTV"
          :selected="
            balanceTypeTV.find((e) => e.value == searchModel.balance_type)
          "
          :placeholder="'Select Balance Type'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('balance_type', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
        <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
      </div>
      <button @click="onApplyFilter" class="dt-button dt-button v5 s8 m8">
        Apply Filter
      </button>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        class="dbox1"
        id="royalty-royalty_accounts-sidewindow-related_contacts-list"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
        @scrollnext="onScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('balance_date')">
              <DatePicker2
                class="dbox1"
                id="balance_date"
                :label="$t('balance_date')"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['balance_date']"
                :bb="'0px'"
                @input="(e) => onDateUpdate(e, item)"
              />
            </td>
            <td v-bind="tdcon('contract_account')">
              <span class="txtov" :title="item['contract_account']">
                {{ item["contract_account"] }}
              </span>
            </td>
            <td v-bind="tdcon('description')">
              <TextField2
                class="dbox1"
                :id="'description'"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['description']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('balance_type')">
              <Dropdown2
                class="dbox1"
                :showLabel="false"
                :disabled="item['disabled']"
                :options="balanceTypeTV"
                :selected="
                  balanceTypeTV.find((e) => e.value == item.balance_type)
                "
                :placeholder="$t('balance_type')"
                v-on:selectedChange="
                  (e) => onDropdownChange('balance_type', e, item)
                "
                :bb="'0px'"
              />
            </td>
            <!-- <td v-bind="tdcon('system_currency_amount')">
              <TextField2
                :ta="'right'"
                :id="'system_currency_amount'"
                :type="'number'"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['system_currency_amount']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td> -->
            <td v-bind="tdcon('balance_amount')">
              <TextField2
                class="dbox1"
                :ta="'right'"
                :id="'balance_amount'"
                :type="'number'"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['balance_amount']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('options')">
              <img
                v-if="item['period'] == 'open_balances'"
                src="static/icons/delete.svg"
                @click.stop="(e) => onBalanceDelete(item)"
                class="dt-icon v5 s1 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { DTIconButton } from "../../../../plugins/button/button";
import DatePicker from "@plugins/text-field/date-picker";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { AccountsService } from "../../services/accounts.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { subscribeSubject } from "../../../../utility";
export default {
  components: {
    DBox,
    NTable,
    DTIconButton,
    DatePicker,
  },
  props: ["selectedAccountDetails", "advanceSearchData"],
  data: () => ({
    searchFlag: false,
    searchModel: {
      str: "",
      balance_type: "",
    },
    searchString: "",
    searchSubject$: new Subject(),
    tableConfig: createNTableConfig({
      headerStyle: 3,
      fullHeight: true,
    }),
    start: 0,
  }),
  mounted() {
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        this.searchModel = {
          ...this.searchModel,
          str: searchString,
        };
        this.searchString = searchString;
        this.onApplyFilter();
      }
    );
  },
  computed: {
    list: function () {
      return this.selectedAccountDetails.balances || [];
    },
    headers: () => [
      createTableHeader("balance_date", {
        text: "Balances",
        f: 0.7,
        mw: 200,
      }),
      createTableHeader("contract_account", {
        text: "Account/Contract",
        ta: "left",
      }),
      createTableHeader("description", { minw: 300, ta: "left" }),
      createTableHeader("type"),
      createTableHeader("balance_amount", {
        text: "Amount EUR",
        ta: "right",
        minw: 40,
        mw: 100,
      }),
      createTableHeader("options", { text: false, mw: 30 }),
    ],
    filterExists() {
      return (
        this.searchModel.str ||
        this.searchModel.balance_type ||
        this.searchModel.account ||
        this.advanceSearchData.start_date ||
        this.advanceSearchData.end_date ||
        this.advanceSearchData.period ||
        this.advanceSearchData.contract ||
        this.advanceSearchData.account ||
        this.advanceSearchData.description ||
        this.advanceSearchData.balance_type
      );
    },
    balanceTypeTV: () => [
      { text: "Advance", value: "1" },
      { text: "Recoupable", value: "2" },
      { text: "Credit Return Reserve", value: "3" },
      { text: "Closing Balance", value: "4" },
      { text: "Royalty Payment", value: "5" },
    ],
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onTextFieldValueChange: function ({ name, value }, item) {
      // item[name] = value;
      // if (name == "amount") {
      //   item["balance_amount"] = (+value).toFixed(2);
      // }
      this.$emit("changed", {
        name,
        value,
        kVal: item.balance_id,
        table: "l_balances",
      });
      // this.updateData(item);
    },
    onDropdownChange: function (name, value, item) {
      // item[name] = value.value;
      this.$emit("changed", {
        name,
        value: value.value,
        kVal: item.balance_id,
        table: "l_balances",
      });
      // this.updateData(item);
    },

    onDateUpdate: function ({ name, value }, item) {
      if (
        new Date(this.selectedAccountDetails.max_end_date).getTime() <=
        new Date(value).getTime()
      ) {
        // console.log("date ");
        // item[name] = value;
        this.$emit("changed", {
          name,
          value,
          kVal: item.balance_id,
          table: "l_balances",
        });
        // this.updateData(item);
      } else {
        NotificationService.showNotification({
          text: `Date must be after ${this.selectedAccountDetails.max_end_date}`,
          timeout: 1500,
          type: "error",
        });
      }
    },
    onRightMenuClick: async function (menu) {
      if (menu === "export") {
        const fileURL = await AccountsService.exportRoyaltyBalaces(
          this.selectedAccountDetails?.account?.royalty_account_id
        );
        // console.log({ fileURL: fileURL });
        location.href = fileURL;
      }
    },
    onBalanceDelete: async function (item) {
     
      if (item.contract_id) {
        const confirmationResult = await confirmDelete(
          "Balance",
          item.contract_account
        );
        if (confirmationResult !== "OK") {
          return;
        }
      }

      const balances = this.selectedAccountDetails.balances.filter(
        (b) => b.balance_id !== item.balance_id
      );
      this[ActionTypes.RoyaltyAccountsBalances.SET.ALL]({
        royalty_account_id: this.selectedAccountDetails?.account?.royalty_account_id,
        balances: balances || [],
      });
      const res = await AccountsService.deleteBalance({ ...item });
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onAddClick: function () {
      this[ActionTypes.INSERT_ROYALTY_ACCOUNT_BALANCE]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
      });
    },
    onAdvancedSearchClick: function () {
      this.$emit("add_click", "balance_advance_search");
    },
    onBadgeClick(badge) {
      if (badge === "reset_filters") {
        this.searchString = "";
        this.searchModel = {
          str: "",
          account: "",
          balance_type: "",
        };
        this.$emit("search", {});
        this.onApplyFilter();
        this.searchFlag = false;
        this.$emit("showSearchFlag", this.searchFlag);
      }
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchModel = {
        ...this.searchModel,
        str: this.searchString,
      };
      this.searchSubject$.next(event.target.value);
    },
    onFilterSelected: function (name, value) {
      this.searchModel[name] = value.value;
      this.onApplyFilter();
    },
    async onApplyFilter() {
      const result = await AccountsService.balanceAdvanceSearch({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        ...this.searchModel,
      });
      this[ActionTypes.RoyaltyAccountsBalances.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        balances: result.data.balances || [],
      });
    },

    // updateData: function (item) {
    //   // console.log("item", item);
    //   const balances = this.selectedAccountDetails.balances.map((b) => {
    //     if (b.balance_id === item.balance_id) {
    //       b = {
    //         ...item,
    //       };
    //     }
    //     return b;
    //   });

    //   this[ActionTypes.RoyaltyAccountsBalances.SET.ALL]({
    //     royalty_account_id:
    //       this.selectedAccountDetails?.account?.royalty_account_id,
    //     balances: balances || [],
    //   });
    // },

    resetFilter: () => ({
      transaction_type: "",
      account_id: "",
      country_id: "",
      period: "",
    }),
    onScroll: function (payload) {
      // console.log("scroll", payload);
      this.start = payload + this.start;
      this.$emit("scroll", this.start);
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-balance {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
    .dropdown {
      margin: 10px;
    }
  }
  /* .dropdown-2 .dropdown.disabled {
    border-color:  hsla(0, 0%, 94%, 1);
    &:hover {
      border-color:  hsla(0, 0%, 80%, 1);
    }
  } */
  /* input {
    &:hover {
      &:disabled {
        background-color: var(--fc2-bc);
        border-color: var(--fc2-bdc);
      }
    }
  } */
  // .dt-ntable {
  //   tr {
  //     td {
  //       justify-content: flex-start;
  //       & > div,
  //       & > span {
  //         margin-top: 8px;
  //       }
  //     }
  //   }
  // }
}
</style>
